export default "__VITE_ASSET__ST_wcDvQ__"